import Seo from "@/components/Seo";
import { PageHero, Section, Btn, SectionHead } from "@/components/kit";
import { Reveal, Eyebrow } from "@/lib/anim";
import { NOT_LIST, TRANSPARENCY } from "@/lib/content";

const BELIEFS = [
  ["Product is a money decision before it is a taste decision.", "The design gets the attention. The arithmetic underneath it decides whether the business survives. Prox works on the arithmetic."],
  ["Buyer-side, always.", "There is no commission on your factory prices, no markup on your quotes, and no referral fee from anyone. The only thing Prox sells is judgement about product and money."],
  ["A price is a filter.", "Publishing prices tells you faster than a sales call whether we should work together. Most consultancies in this market publish nothing. Prox publishes everything."],
  ["Small on purpose.", "Two retainer clients at a time, so the person you hire is the person doing the work. When a piece of work is not worth doing, you will be told."],
  ["Every contact stays yours.", "Suppliers introduced through Prox become your relationships permanently. Nothing is held back to protect a fee."],
];

export default function Vision() {
  return (
    <>
      <Seo title="Vision" canonical="/vision" description="What Prox believes about product, money and the way a buyer-side advisory should work." />
      <PageHero
        eyebrow="Vision"
        crumbs={[{ label: "Home", to: "/" }, { label: "Vision" }]}
        title="A different idea of what a product consultant is for."
        lead="Prox is built on a small set of beliefs about product, money and how a buyer-side practice should behave."
      />
      <Section bg="bone">
        <div className="border-t border-[var(--stone)]">
          {BELIEFS.map((b, i) => (
            <Reveal i={i % 2} key={b[0]}>
              <div className="grid md:grid-cols-12 gap-6 py-10 border-b border-[var(--stone)]">
                <div className="md:col-span-1 font-mono text-[var(--clay)]">0{i + 1}</div>
                <h2 className="md:col-span-6 t-h3">{b[0]}</h2>
                <p className="md:col-span-5 t-body text-[var(--muted)]">{b[1]}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </Section>
      <Section bg="paper">
        <div className="grid lg:grid-cols-2 gap-12">
          <div><Eyebrow>What Prox is not</Eyebrow><p className="t-body measure">{NOT_LIST}</p></div>
          <div className="border-l border-[var(--stone)] pl-8"><Eyebrow>Who pays Prox</Eyebrow><p className="t-body measure">{TRANSPARENCY}</p></div>
        </div>
      </Section>
      <Section bg="charcoal" dark className="py-20 md:py-24">
        <div className="max-w-3xl">
          <h2 className="t-display2">If that sounds like the help you need.</h2>
          <Btn to="/book" variant="clay" className="mt-9">Book the free fit call</Btn>
        </div>
      </Section>
    </>
  );
}
